import { render, staticRenderFns } from "./DataTableDateOnlyColumn.vue?vue&type=template&id=742e7e3d&"
import script from "./DataTableDateOnlyColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableDateOnlyColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports